module.exports = __webpack_public_path__ + "img/logo.eab9561d.svg";